class LazyVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector("video");

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.video.src = this.video.querySelector("source").dataset.src;
          this.observer.unobserve(this);
        } else {
          // this.video.pause()
        }
      },
      { rootMargin: "0px 0px -30px 0px" }
    );
    this.observer.observe(this);
  }
}

window.customElements.define("lazy-video", LazyVideo);
